import { render, staticRenderFns } from "./AddChildrenToOrderDialog.vue?vue&type=template&id=7e36fb06&"
import script from "./AddChildrenToOrderDialog.vue?vue&type=script&lang=js&"
export * from "./AddChildrenToOrderDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddChildrenToOrderDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports